import './translateGuard';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/globals.css';
import './panel/panel.global.css';
import App from './components/App';
import ErrorBoundary from './components/ErrorBoundary';
import reportWebVitals from './reportWebVitals';

// Analytics de Cloudflare (Web Analytics): sin cookies y sin datos personales.
// Solo se carga en producción y si hay token (REACT_APP_CF_ANALYTICS_TOKEN).
const cfAnalyticsToken = process.env.REACT_APP_CF_ANALYTICS_TOKEN;
if (cfAnalyticsToken && process.env.NODE_ENV === 'production') {
  const beacon = document.createElement('script');
  beacon.defer = true;
  beacon.src = 'https://static.cloudflareinsights.com/beacon.min.js';
  beacon.setAttribute('data-cf-beacon', JSON.stringify({ token: cfAnalyticsToken, spa: true }));
  document.head.appendChild(beacon);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
